/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-23 09:04:20
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-11 17:45:46
 */
// const crypto = require('crypto');
import Vue from 'vue'
import CryptoJS from 'crypto-js'
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function() {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
                // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function(...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
            // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

export const getUrlParams = (url) => {
    let a = url.split('&'),
        res = {}
    for (let i of a) {
        let key = i.split('=')[0],
            val = i.split('=')[1]
        if (key && val !== undefined) res[key] = val
    }
    return res
}


//获取cookie
export const getCookie = (name) => {
        let arrCookie = document.cookie.split(";")
        for (let i = 0; i < arrCookie.length; i++) {
            let arr = arrCookie[i].split("=") //从 = 的位置 分割每对cookie
            if (arr[0].replace(/(^\s*|\s*$)/g, "") === name) { //存在此cookie
                return (arr[1] ? decodeURIComponent(arr[1]) : null) //若值不为空，返回此值，否则返回null
            }
        }
        return null
    }
    //设置cookie
export const setCookie = (name, val, time = 7 * 24 * 60 * 60 * 1000, path, domain) => {
        let exp = new Date(),
            p = path ? ';path=' + path : ';path=/',
            d = domain ? ';domain=' + domain : ''
        exp.setTime(exp.getTime() + time) //默认7天过期, 删除cookie传入负值即可
        document.cookie = name + "=" + encodeURIComponent(val) + ";expires=" + exp.toGMTString() + p + d
    }
    // 数据DES加密
export const aseEncode = (word, keyStr) => {
        var keyHex = CryptoJS.enc.Utf8.parse(keyStr);
        var encrypted = CryptoJS.DES.encrypt(word, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.ciphertext.toString();
    }
    // 数据DES解密
export const aseDecode = (word, keyStr) => {
    var keyHex = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypted = CryptoJS.DES.decrypt({
        ciphertext: CryptoJS.enc.Hex.parse(word)
    }, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    var result_value = decrypted.toString(CryptoJS.enc.Utf8);
    return result_value;
}
/**
 * 在使用 clipboard.js 复制时，必须有一个由用户手动发起事件，不然调用不成功。但可以采用取巧的办法解决：
 * 这样，就可以随时调用而不需要创建 DOM了~
 * 参考：https://www.jianshu.com/p/89167339782c
 */
export function copyText(text, evt) {
    let cb = new Clipboard('#copy-text', {
        text: function() {
            return text
        }
    })
    cb.on('success', function(e) {
        Vue.prototype.$toast('复制成功','success',1000)
        cb.off('error')
        cb.off('success')
    })
    cb.on('error', function(e) {
        Vue.prototype.$toast('复制失败，请重试','error',2000)
        cb.off('error')
        cb.off('success')
    })
    cb.onClick(evt)
}


// WEBPACK FOOTER //
// ./src/js/utils.js